module.exports = __webpack_public_path__ + "static/media/roseChatPopup2x.3777960a.png";